import { z } from "zod";
import { SYSTEMS_PER_GALAXY } from "../constants/resources.js";
/**
 * Request body for the `/getSolarSystem` endpoint. Galaxy count is a server
 * deployment choice (usually ≤ 9, theoretically unbounded), so only a sane
 * ceiling is enforced here; system count is fixed per server config.
 */
export const GetSolarSystemSchema = z.object({
    galaxy: z.number().int().min(1).max(999),
    system: z.number().int().min(1).max(SYSTEMS_PER_GALAXY),
});
//# sourceMappingURL=galaxy.schemas.js.map